import React from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { Clear as ClearIcon, Search as SearchIcon } from '@mui/icons-material';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { SearchBarProps } from '../../helpers/types';
import GradientButton from '../Button/GradientButton';
import ToggleSwitch from '../ToggleSwitch/ToggleSwitch';
import { SearchBarEndAdornment, SearchBarStyle } from './Searchbar.style';

const SearchBar = ({
  size,
  handleChange,
  handleSearch,
  searchValue,
  handleClearSearch,
  bypassFilters = false,
  onToggleBypass,
  bypassSearching = false,
  bypassProgressText,
  onCancelBypassSearch,
}: SearchBarProps) => {
  const isSearchDisabled = !searchValue.trim();

  return (
    <>
      <TextField
        size={size}
        onChange={handleChange}
        value={searchValue}
        sx={SearchBarStyle}
        placeholder="Search"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
          endAdornment: searchValue && (
            <IconButton onClick={handleClearSearch} sx={SearchBarEndAdornment}>
              <ClearIcon />
            </IconButton>
          ),
        }}
      />
      <GradientButton
        data-testid="search-button"
        variant="contained"
        label={bypassSearching ? 'Searching...' : 'Search'}
        onClick={handleSearch}
        disabled={isSearchDisabled || bypassSearching}
      />
      {onToggleBypass && (
        <Tooltip
          title="Ignores all active filters and searches year by year across the entire system"
          arrow
          placement="bottom"
        >
          <Box sx={{ display: 'flex', alignItems: 'center', ml: 1, gap: 0.5 }}>
            <ToggleSwitch
              checked={bypassFilters}
              handleChange={onToggleBypass}
            />
            <Typography
              sx={{
                fontSize: 12,
                whiteSpace: 'nowrap',
                userSelect: 'none',
                color: 'text.secondary',
              }}
            >
              Bypass Filters
            </Typography>
          </Box>
        </Tooltip>
      )}
      {bypassProgressText && (
        <Box sx={{ display: 'flex', alignItems: 'center', ml: 1.5, gap: 1 }}>
          <Typography
            data-testid="bypass-progress-text"
            sx={{
              fontSize: 12,
              color: 'text.secondary',
              whiteSpace: 'nowrap',
            }}
          >
            {bypassProgressText}
          </Typography>
          {bypassSearching && onCancelBypassSearch && (
            <Typography
              data-testid="bypass-stop-button"
              component="span"
              onClick={onCancelBypassSearch}
              sx={{
                fontSize: 12,
                color: 'error.main',
                cursor: 'pointer',
                textDecoration: 'underline',
                whiteSpace: 'nowrap',
              }}
            >
              Stop
            </Typography>
          )}
        </Box>
      )}
    </>
  );
};

export default SearchBar;
